import { render } from "./SubList.vue?vue&type=template&id=5f4dbffa&scoped=true"
import script from "./SubList.vue?vue&type=script&lang=js"
export * from "./SubList.vue?vue&type=script&lang=js"

import "./SubList.vue?vue&type=style&index=0&id=5f4dbffa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f4dbffa"

export default script